// useFilePreview.js
import { useState, useCallback } from "react";

export default function useFilePreview(initialUrl = "") {
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(initialUrl);

  const onFileChange = useCallback((e) => {
    const f = e.target.files[0];
    if (f) {
      setFile(f);
      setPreview(URL.createObjectURL(f));
    } else {
      setFile(null);
      setPreview("");
    }
  }, []);

  const clear = useCallback(() => {
    setFile(null);
    setPreview("");
  }, []);

  return { file, preview, onFileChange, clear };
}
